import {
  ALBUM_LIST_LOADING,
  GET_ALBUM_LIST,
  GET_ALBUM_LIST_ERROR,
  GET_ALBUM_BY_ID_LOADING,
  GET_ALBUM_BY_ID_SUCCESS,
  GET_ALBUM_BY_ID_ERROR,
  DELETEING_ALBUM,
  DELETE_ALBUM,
  DELETE_ALBUM_ERROR,
  DELETED_ALBUM_LIST_LOADING,
  GET_DELETED_ALBUM_LIST,
  GET_DELETED_ALBUM_LIST_ERROR,
  PERMA_DELETEING_ALBUM,
  PERMA_DELETE_ALBUM,
  PERMA_DELETE_ALBUM_ERROR,
  RESTORE_ALBUM_LIST_LOADING,
  RESTORE_ALBUM_LIST,
  RESTORE_ALBUM_LIST_ERROR,
} from "./types";
import axios from "axios";
import { BASE_URL } from "../urls";
import { message } from "antd";

export const getList = (tokenData) => async (dispatch) => {
  dispatch({
    type: ALBUM_LIST_LOADING,
  });
  await axios
    .get(`${BASE_URL}api/v1/admin/carousel/active`, {
      headers: {
        Authorization: `${tokenData.token_type} ${tokenData.access_token}`,
      },
    })
    .then(function (response) {
      dispatch({
        type: GET_ALBUM_LIST,
        payload: response,
      });
    })
    .catch(function (error) {
      dispatch({
        type: GET_ALBUM_LIST_ERROR,
        payload: error.response,
      });
    });
};

export const getEntityById = (tokenData, id) => async (dispatch) => {
  dispatch({
    type: GET_ALBUM_BY_ID_LOADING,
  });
  await axios
    .get(`${BASE_URL}api/v1/admin/carousel/active/${id}`, {
      headers: {
        Authorization: `${tokenData.token_type} ${tokenData.access_token}`,
      },
    })
    .then(function (response) {
      dispatch({
        type: GET_ALBUM_BY_ID_SUCCESS,
        payload: response,
      });
    })
    .catch(function (error) {
      dispatch({
        type: GET_ALBUM_BY_ID_ERROR,
        payload: error.response,
      });
    });
};

export const getDeletedList = (tokenData) => async (dispatch) => {
  dispatch({
    type: DELETED_ALBUM_LIST_LOADING,
  });
  await axios
    .get(`${BASE_URL}api/v1/admin/carousel/deleted`, {
      headers: {
        Authorization: `${tokenData.token_type} ${tokenData.access_token}`,
      },
    })
    .then(function (response) {
      dispatch({
        type: GET_DELETED_ALBUM_LIST,
        payload: response,
      });
    })
    .catch(function (error) {
      dispatch({
        type: GET_DELETED_ALBUM_LIST_ERROR,
        payload: error.response,
      });
    });
};

export const deleteEntityById = (idList) => async (dispatch) => {
  dispatch({
    type: DELETEING_ALBUM,
  });
  let bulk = { bulk: idList };
  await axios
    .post(`${BASE_URL}api/v1/admin/carousel/bulk/delete`, bulk, {
      headers: {
        Authorization: `${localStorage.token_type} ${localStorage.access_token}`,
      },
    })
    .then(function (response) {
      dispatch({
        type: DELETE_ALBUM,
        payload: response,
      });
      message.success(response.data.message);
    })
    .catch(function (error) {
      dispatch({
        type: DELETE_ALBUM_ERROR,
        payload: error.response,
      });
      message.error(error.response.data.message);
    });
};

export const permanentDeleteEntity = (idList) => async (dispatch) => {
  dispatch({
    type: PERMA_DELETEING_ALBUM,
  });
  let bulk = { bulk: idList };
  await axios
    .post(`${BASE_URL}api/v1/admin/carousel/bulk/perma-delete`, bulk, {
      headers: {
        Authorization: `${localStorage.token_type} ${localStorage.access_token}`,
      },
    })
    .then(function (response) {
      dispatch({
        type: PERMA_DELETE_ALBUM,
        payload: response,
      });

      message.success(response.data.message);
    })
    .catch(function (error) {
      dispatch({
        type: PERMA_DELETE_ALBUM_ERROR,
        payload: error.response,
      });

      message.error(error.response.data.message);
    });
};

export const restoretDeleteEntity = (idList) => async (dispatch) => {
  dispatch({
    type: RESTORE_ALBUM_LIST_LOADING,
  });
  let bulk = { bulk: idList };
  await axios
    .post(`${BASE_URL}api/v1/admin/carousel/bulk/restore`, bulk, {
      headers: {
        Authorization: `${localStorage.token_type} ${localStorage.access_token}`,
      },
    })
    .then(function (response) {
      dispatch({
        type: RESTORE_ALBUM_LIST,
        payload: response,
      });
      message.success(response.data.message);
    })
    .catch(function (error) {
      dispatch({
        type: RESTORE_ALBUM_LIST_ERROR,
        payload: error.response,
      });
      message.error(error.response.data.message);
    });
};
